// extracted by mini-css-extract-plugin
export default {"parent":"cartRoomSlot_parent__6Vwi1","parentFree":"cartRoomSlot_parentFree__bzLph"};